import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Loader } from '../../../Shared/Loader';
import { history } from '../../../../_helpers';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ProgressBar from 'react-bootstrap/ProgressBar';

class ImpactFocusGroups extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: JSON.parse(localStorage.getItem('user')),
            focus_areas: JSON.parse(localStorage.getItem('focus_areas')),
            impact_groups: [],
            loading: true,
        }
    }

    componentDidMount() {
        this.setState({
            impact_groups: {
                ...this.state.impact_groups,
                impact_group_women_girls: false,
                impact_group_men: false,
                impact_group_veterans: false,
                impact_group_disadvantaged_communities: false,
                impact_group_LGBTQA: false,
                impact_group_communities_color: false,
                impact_group_rural_communities: false,
                impact_group_physically_disabled: false,
                impact_group_mentally_disabled: false,
                impact_group_other: false
            }
        })
        
        document.body.scrollTop = 0;
    
        setTimeout(() => {
            this.setState({
            loading: false
            });
        }, 500);
    }

    useStyles = makeStyles((theme) => ({
            root: {
              display: 'flex',
            },
            formControl: {
              margin: theme.spacing(3),
            },
    }));
          
    CheckboxesGroup() {
        const classes = this.useStyles();
    };
          
    handleChange = (event) => {
        const category = [event.target.name];

        this.setState({ 
            ...this.state, 
            [event.target.name]: event.target.checked,
            impact_groups: {
                ...this.state.impact_groups,
                [category]: event.target.checked 
            }
        });
    };
    
    handleNavigation = async (type) => {
        var {user, impact_groups} = this.state;
        
        await localStorage.setItem('user', JSON.stringify(user));
        await localStorage.setItem('impact_groups', JSON.stringify(impact_groups));
        history.push('/quickstart/finished');
    }

    render() {     
        const { loading } = this.state;
        const { whitelabel } = this.props;
        const progressBarColor = whitelabel ? whitelabel.accent_Color : "#29a";
        const now = 70;
        const progressInstance = <ProgressBar now={now} label={`${now}%`} />;

        return (
            <div>
                <style>{"\
                    .progress-bar{\
                    background:" + progressBarColor + ";\
                    }\
                    .#NSF_Category_Selector .MuiSvgIcon-root{\
                        fill:" + progressBarColor + ";\
                    }\
                "}</style>
                {loading && <Loader />}
                <div>{progressInstance}</div>
                <div id="fundingSlider1">
                    <h1 id="fundingSliderHeader" style={{marginBottom: "2%"}}>
                        Who are you generating impact for?
                    </h1>
                </div>
                <hr style={{width: "7%", height: 5, background: "#999"}} />
                <div id="NSF_Category_Selector">
                    <FormControl component="fieldset" className="">
                        <FormGroup>
                            <div id="focusNSFArea" className="row">
                                <h3 id="checkAllH3">Check all areas that apply</h3>
                                <hr />
                                    <FormControlLabel
                                        control={<Checkbox 
                                                    checked={this.state.impact_groups.impact_group_women_girls} 
                                                    onChange={this.handleChange} 
                                                    name="impact_group_women_girls" 
                                                    style={{color: whitelabel ? whitelabel.accent_Color : "#29a"}}
                                                />}
                                        label="Women & Girls"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox 
                                                    checked={this.state.impact_groups.impact_group_men} 
                                                    onChange={this.handleChange} 
                                                    name="impact_group_men" 
                                                    style={{color: whitelabel ? whitelabel.accent_Color : "#29a"}}
                                                />}
                                        label="Men"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox 
                                                    checked={this.state.impact_groups.impact_group_veterans} 
                                                    onChange={this.handleChange} 
                                                    name="impact_group_veterans" 
                                                    style={{color: whitelabel ? whitelabel.accent_Color : "#29a"}}
                                                />}
                                        label="Veterans"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox 
                                                    checked={this.state.impact_groups.impact_group_disadvantaged_communities} 
                                                    onChange={this.handleChange} 
                                                    name="impact_group_disadvantaged_communities" 
                                                    style={{color: whitelabel ? whitelabel.accent_Color : "#29a"}}
                                                />}
                                        label="Disadvantaged Communities"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox 
                                                    checked={this.state.impact_groups.impact_group_LGBTQA} 
                                                    onChange={this.handleChange} 
                                                    name="impact_group_LGBTQA" 
                                                    style={{color: whitelabel ? whitelabel.accent_Color : "#29a"}}
                                                />}
                                        label="LGBTQA+"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox 
                                                    checked={this.state.impact_groups.impact_group_communities_color} 
                                                    onChange={this.handleChange} 
                                                    name="impact_group_communities_color" 
                                                    style={{color: whitelabel ? whitelabel.accent_Color : "#29a"}}
                                                />}
                                        label="Communities of Color"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox 
                                                    checked={this.state.impact_groups.impact_group_rural_communities} 
                                                    onChange={this.handleChange} 
                                                    name="impact_group_rural_communities" 
                                                    style={{color: whitelabel ? whitelabel.accent_Color : "#29a"}}
                                                />}
                                        label="Rural Communities"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox 
                                                    checked={this.state.impact_groups.impact_group_physically_disabled} 
                                                    onChange={this.handleChange} 
                                                    name="impact_group_physically_disabled" 
                                                    style={{color: whitelabel ? whitelabel.accent_Color : "#29a"}}
                                                />}
                                        label="People with Physically Impairments"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox 
                                                    checked={this.state.impact_groups.impact_group_mentally_disabled} 
                                                    onChange={this.handleChange} 
                                                    name="impact_group_mentally_disabled" 
                                                    style={{color: whitelabel ? whitelabel.accent_Color : "#29a"}}
                                                />}
                                        label="People with Cognitive Impairments"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox 
                                                    checked={this.state.impact_groups.impact_other} 
                                                    onChange={this.handleChange} 
                                                    name="impact_other" 
                                                    style={{color: whitelabel ? whitelabel.accent_Color : "#29a"}}
                                                />}
                                        label="Other"
                                    />
                                <div id="NSFFocusContinueButton" className="continueButton">
                                    <button 
                                        className="signUpContinue"
                                        onClick={() => this.handleNavigation('next')}
                                        style={{background: whitelabel ? whitelabel.button_Color : "#29a"}}
                                    >
                                        Continue  →
                                    </button>
                                </div>
                            </div>
                        </FormGroup>
                    </FormControl>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { registering, nav } = state.registration;
    const { whitelabel } = state.setWhitelabel;
    const { registrationAlert } = state;
    
    return {
        registering, 
        nav, 
        registrationAlert,
        whitelabel,
    };
}

const connectedImpactFocusGroups = withRouter(connect(mapStateToProps)(ImpactFocusGroups));
export { connectedImpactFocusGroups as ImpactFocusGroups };